/* eslint-disable @typescript-eslint/no-explicit-any */
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/auth";
import { toast } from "react-toastify";
import { useEffect, useMemo, useState } from "react";
import envs from "../../config/envs";
import { UserAuth, } from "../../modules/auth/AuthState";
import { addPaymentMethod, getBillingHistory, getPaymentMethods, getProducts, removePaymentMethod, setDefaultPaymentMethod, subscriptionDowngrade, subscriptionUpgrade } from "../onboarding/api";
import { IoCheckmark } from "react-icons/io5";
import { ModelListPaymentMethodsResponse, ModelListPaymentProductsResponse, ModelPaymentMethod, ModelPaymentProduct } from "../../api/__gen__/data-contracts";
import { DatePicker, Modal, Popconfirm, Table, Tag } from "antd";
import { loadStripe } from '@stripe/stripe-js';
import CreditCardInfo from "../onboarding/CreditCardInfo";
import {
  Elements,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import VisaSvg from './assets/Visa.svg'
import mastercard from './assets/Mastercard.svg'
import jcb from './assets/jcb.svg'
import Default from './assets/default.svg'

const ActiveButton = () => {
  return <div className="bg-[#f4f5ff] border-[#263dff] border rounded w-full p-3 cursor-pointer">
    <div className="text-[#263dff] font-semibold text-lg flex items-center justify-center gap-2">
      <IoCheckmark /> Active
    </div>
  </div>
}

const DowngradeButton = ({ onClick }: {
  onClick?: () => void;
}) => {
  return <div className="bg-[#fafafa] border-[#e2e2e3] border rounded w-full p-3 cursor-pointer">
    <div className="text-[#191919] font-semibold text-lg flex items-center justify-center gap-2" onClick={onClick}>
      Downgrade
    </div>
  </div>
}

const UpgradeButton = ({ onClick, planChosen }: {
  onClick: any;
  planChosen?: boolean;
}) => {
  return <div className="bg-[#263dff] border-[#263dff] border rounded w-full p-3 cursor-pointer">
    <Popconfirm title="Are you sure to upgrade to Bulder Plan?" onConfirm={onClick} onCancel={() => { }} okButtonProps={{
      style: {
        backgroundColor: '#253cf7',
        borderColor: '#253cf7',
        fontWeight: '600'
      }
    }}>
      <div className="text-[#fff] font-semibold text-lg flex items-center justify-center gap-2" >
        {
          planChosen ? 'Upgrade' : 'Subscribe'
        }
      </div>
    </Popconfirm>
  </div>
}

const ContactUsButton = () => {
  return <div className="bg-[#263dff] border-[#263dff] border rounded w-full p-3 cursor-pointer">
    <a href="mailto:sales@zettablock.com" className="w-full">
      <div className="text-[#fff] font-semibold text-lg flex items-center justify-center gap-2">
        Contact Us
      </div>
    </a>

  </div>
}

const AddCardModal = ({
  open,
  onCancel,
  onSubmit,
  hasDefault
}: {
  open: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  hasDefault?: boolean;
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [{ auth }] = useAuth();
  const [isDefault, setIsDefault] = useState(false)

  const handleSubmit = async () => {
    if (!elements) return

    const token = await stripe?.createToken(elements.getElement('cardNumber')!);

    if (token?.token?.id) {
      await addPaymentMethod(auth?.id || "", token?.token?.id || "", 'card', hasDefault ? isDefault : true)
      toast.success('Payment method added', { autoClose: 2000 })
      onSubmit()
      onCancel()
    }
  }

  return <Modal
    open={open}
    onCancel={onCancel}
    onOk={handleSubmit}
  >
    this
    <CreditCardInfo onSubmit={() => { }} />
    {
      hasDefault && <div className='px-8 flex items-center justify-start'>
        <input type="checkbox" width={20} onChange={(e) => { setIsDefault(e.target.checked) }} />

        <div className='ml-2'>
          <label htmlFor="card-holder-name" className="text-[#777A80]" >
            Set as default
          </label>
        </div>
      </div>
    }

  </Modal>
}

const Billing = () => {
  const stripePromise = loadStripe('pk_test_51LpQfhFfZvE8Y7MuLM9Ez9wXVyi1j6ywQ7hewHDtkXc9hi1RFktnUMVnXGv2A7KDN4B98gwglFNgBQCYTL9UtWfu00NkLMAR9z');

  const options = {
    mode: 'payment',
    amount: 1099,
    currency: 'usd',
    // Fully customizable with appearance API.
    appearance: {
    },
  };



  const [methods, setMethods] = useState<ModelPaymentMethod[]>([])
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [products, setProducts] = useState<ModelPaymentProduct[]>([])

  const [showModal, setShowModal] = useState(false)

  const [{ auth }, { setAuth }] = useAuth();
  const fetchAndSetPaymentMethods = async () => {
    if (auth) {
      const res: ModelListPaymentMethodsResponse = await getPaymentMethods(auth.id)

      if (res && res && res.payment_methods) {
        setMethods(res.payment_methods)
      }
    }
  }

  const [billingRange, setBillingRange] = useState<any>(null)

  const [billingHistory, setBillingHistory] = useState<any>([])
  const fetchAndSetBillingHistory = async () => {
    if (auth && billingRange) {
      const resp = await getBillingHistory(auth.id, {
        start_time: `${billingRange[0].toISOString().slice(0, 10)}T00:00:00`,
        end_time: `${billingRange[0].toISOString().slice(0, 10)}T23:59:59`
      })
      setBillingHistory(resp?.transaction_histories || [])
    }
  }

  useEffect(() => {
    fetchAndSetBillingHistory()
  }, [auth, billingRange])


  const onSubmit = async () => {
    await fetchAndSetPaymentMethods()
  }

  const onRemove = async (id: string) => {
    await removePaymentMethod(auth?.id || "", id, auth?.tenant || "")
    toast.success('Payment method removed', { autoClose: 2000 })
    await fetchAndSetPaymentMethods()
  }

  const getIcon = (brand: string) => {
    switch (brand) {
      case 'visa':
        return VisaSvg
      case 'mastercard':
        return mastercard
      case 'jcb':
        return jcb
      default:
        return Default
    }
  }

  const onSetDefault = async (id: string) => {
    await setDefaultPaymentMethod(auth?.id || "", id)
    toast.success('Payment method removed', { autoClose: 2000 })
    await fetchAndSetPaymentMethods()
  }

  const fetchAndSetProducts = async () => {
    if (auth) {
      const res: ModelListPaymentProductsResponse = await getProducts(auth.id)

      if (res && res && res.products) {
        setProducts(res.products)
      }
    }

  }

  useEffect(() => {
    fetchAndSetPaymentMethods()
    fetchAndSetProducts()
  }, [auth])

  // https://checkout.zettablock.com/b/28o4iffVh8VR1S8002

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const navigate = useNavigate();
  const isFreePlan = useMemo(() => {
    return auth?.subscription?.plan === 'free' && auth?.subscription?.planChosen === true
  }, [
    auth
  ]);
  const noPlan = useMemo(() => {
    return auth?.subscription?.planChosen !== true
  }, [auth])

  const isEnterprisePlan = useMemo(() => {
    return auth?.subscription?.plan === 'enterprise'
  }, [auth])
  // const isBuilderPlan = useMemo(() => {
  //   return auth?.subscription?.plan === 'build'
  // }, [auth])

  const onUpgrade = async (type: string) => {
    const defaultPaymentMethod = methods.find((method) => {
      return method.is_default
    })

    if (!defaultPaymentMethod) {
      toast.error('Please add a payment method first', { autoClose: 2000 })
      return
    }

    if (type === 'free') {
      await subscriptionUpgrade(auth?.id || "", envs.STRIPE_PRODUCT_ID_FREE, defaultPaymentMethod?.id || '', type)
      setAuth((prev: UserAuth | null | undefined) => {
        if (prev) return {
          ...prev,
          subscription: {
            ...prev.subscription,
            plan: 'free'
          }
        }
        return null
      })
    } else if (type === 'build') {
      await subscriptionUpgrade(auth?.id || "", envs.STRIPE_PRODUCT_ID_BUILD, defaultPaymentMethod?.id || '', type)
      setAuth((prev: UserAuth | null | undefined) => {
        if (prev) return {
          ...prev,
          subscription: {
            ...prev.subscription,
            plan: 'build'
          }
        }
        return null
      })
    } else {
      toast.error('Something went wrong')
    }
  }

  const onDowngrade = async (type: string) => {
    const defaultPaymentMethod = methods.find((method) => {
      return method.is_default
    })
    if (type === 'free') {
      await subscriptionDowngrade(auth?.id || "", envs.STRIPE_PRODUCT_ID_FREE, undefined, type)
      setAuth((prev: UserAuth | null | undefined) => {
        if (prev) return {
          ...prev,
          subscription: {
            ...prev.subscription,
            plan: 'free'
          }
        }
        return null
      })
    } else if (type === 'build') {
      await subscriptionDowngrade(auth?.id || "", envs.STRIPE_PRODUCT_ID_BUILD, defaultPaymentMethod?.id || '', type)
      setAuth((prev: UserAuth | null | undefined) => {
        if (prev) return {
          ...prev,
          subscription: {
            ...prev.subscription,
            plan: 'build'
          }
        }
        return null
      })
    } else {
      toast.error('Something went wrong')
    }
  }

  const renderButton = (type: string) => {
    switch (type) {
      case 'free':
        if (noPlan) {
          return <UpgradeButton planChosen={false} onClick={() => {
            onUpgrade('free')
          }} />
        }
        if (!isFreePlan) {
          return <DowngradeButton onClick={() => {
            onDowngrade('free')
          }} />
        }
        return <ActiveButton />

      case 'build':
        if (noPlan) {
          return <UpgradeButton planChosen={false} onClick={() => {
            onUpgrade('build')
          }} />
        }
        if (isFreePlan) {
          return <UpgradeButton planChosen onClick={() => {
            onUpgrade('build')
          }} />
        }
        if (isEnterprisePlan) {
          return <DowngradeButton onClick={() => {
            onDowngrade('build')
          }} />
        }
        return <ActiveButton />

      case 'enterprise':
        if (!isEnterprisePlan) {
          return <ContactUsButton />
        }

        return <ActiveButton />

      default:
        return <UpgradeButton onClick={() => { }} />
    }
  }

  if (!auth) return null

  return <div className="p-16 max-w-[1500px] mx-auto">
    <div className="text-3xl font-semibold">
      My Plan
    </div>

    {/* cards */}
    <div className="flex justify-start bg-[#fff] gap-8 mt-8">
      <div className="p-6 flex-1 border rounded max-w-[320px]">
        <h4 className="font-bold text-2xl mb-1 text-[#263dff]">
          Free
        </h4>
        <p className="text-sm text-[#a3a3a3] mb-8">
          Great for developers, traders, or anyone getting started.
        </p>
        <div className="flex mb-4 items-baseline">
          <span className="font-semibold text-3xl pr-1">
            $0
          </span>
          <div className="text-md font-semibold">
            <p>/ Month</p>
          </div>
        </div>
        <div className="flex mb-4">
          {
            renderButton('free')
          }

        </div>

        <div className="">
          <p>
            It includes:
          </p>
          <ul className="text-sm list-disc list-inside text-[#1a1a1a]">
            <li>3 Million compute units</li>
            <li>1 GraphQL APIs built</li>
            <li>CSV upload 5 times</li>
            <li>CSV download 0 times</li>
            <li>Build your own real-time GraphQL API</li>
            <li>Access to 8+ chains data</li>
            <li>Access to Community data/ APIs/ queries/ dashboards</li>
            <li>Unlimited queries/ charts/ dashboards</li>
            <li>Discord support</li>
            <li>0 private API / query / Dashboard</li>
          </ul>
        </div>

      </div>
      <div className="p-6 bg-[#fff] flex-1 border rounded max-w-[320px]">
        <h4 className="font-bold text-2xl mb-1 text-[#263dff]">
          Builder
        </h4>
        <p className="text-sm text-[#a3a3a3] mb-8">
          Ultimate scalability for professional individuals working in web3.
        </p>
        <div className="flex mb-4 items-baseline">
          <span className="font-semibold text-3xl pr-1">
            $49
          </span>
          <div className="text-md font-semibold">
            <p>/ Month</p>
          </div>
        </div>
        <div className="flex mb-4">
          {
            renderButton('build')
          }

        </div>

        <div className="">
          <p>
            It includes:
          </p>
          <ul className="text-sm list-disc list-inside text-[#1a1a1a]">
            <li>10 Million compute units</li>
            <li>3 GraphQL APIs built</li>
            <li>CSV uploads 15 times</li>
            <li>CSV downloads 15 times</li>
            <li>Auto-scaling at $20 / additional million</li>
            <li>20 requests /sec for GraphQL APIs</li>
            <li>50MB data limit for Data Lake APIs</li>
            <li>Discord support</li>
            <li>0 private API / query / Dashboard</li>
          </ul>
        </div>

      </div>
      <div className="p-6 bg-[#fff] flex-1 border rounded max-w-[320px]">
        <h4 className="font-bold text-2xl mb-1 text-[#263dff]">
          Enterprise
        </h4>
        <p className="text-sm text-[#a3a3a3] mb-8">
          Volume pricing and enterprise support for institutional use cases.
        </p>
        <div className="flex mb-4">
          <span className="font-semibold text-3xl pr-1">
            Contact Support
          </span>
          {/* <div className="text-xs text-[#a3a3a3]">
          <p>per</p>
          <p>month</p>
        </div> */}
        </div>
        <div className="flex mb-4 flex-wrap">
          <a href="mailto:sales@zettablock.com" className="w-full">

          </a>
          {
            renderButton('enterprise')
          }
        </div>

        <div className="">
          <p>
            It includes:
          </p>
          <ul className="text-sm list-disc list-inside text-[#1a1a1a]">
            <li>Custom compute units</li>
            <li>Custom GraphQL APls built</li>
            <li>Custom data ETL pipelines</li>
            <li>Custom CSV Downloads</li>
            <li>Committed use discounts</li>
            <li>Custom SLAs</li>
            <li>Custom requests / sec for GraphQL API</li>
            <li>Custom data limit for Data Lake APIs</li>
            <li>Custom EL pipeline sync frequency</li>
            <li>Premium Onboarding and Support</li>
            <li>Private API / Queries</li>
          </ul>
        </div>

      </div>
    </div>


    <div className="text-3xl font-semibold mt-16">
      Payment Methods
    </div>
    <div className="flex flex-wrap gap-8 mt-6">
      {
        methods.map((method) => {
          return <div className="w-[320px] p-4 border rounded">
            <div className="flex justify-between">
              <div className="text-[#263DFF] font-bold text-lg">
                **** **** **** {method.details?.last4}
              </div>
              <div>
                {/* {method.details?.brand} */}
                <div className="w-10">
                  <img src={VisaSvg} />
                </div>
              </div>
            </div>
            <div className="flex justify-between mt-3 items-center">
              <div className="text-[#777D89]">
                Exp. {method.details?.expmonth}/{method.details?.expyear?.toString().slice(2)}
              </div>
              <div>
                {method.is_default ? <span className="text-[#aeb3bd] text-sm bg-[#e3e6ed] px-1 py-[2px]">Default</span> : <div className="flex gap-3 text-xs cursor-pointer">
                  <div className="text-[#AAAFBA]" onClick={() => {
                    onSetDefault(method.id || '')
                  }}
                  >Set as default</div>
                  <div className="text-[#e81b1b] font" onClick={() => {
                    onRemove(method.id || '')
                  }}>Remove</div>
                </div>}
              </div>
            </div>
          </div>
        })
      }
      <div className="w-[320px] h-[98px] p-4 border rounded items-center justify-center flex text-[#263dff] text-xs cursor-pointer" onClick={() => { setShowModal(true) }}>
        <span>+ Add Card</span>
      </div>
    </div>

    <div className="text-3xl font-semibold mt-16 flex justify-between items-center">
      <div>
        Billing History
      </div>
      <div>
        <DatePicker.RangePicker
          value={billingRange}
          onChange={(e) => {
            setBillingRange(e)
          }}
        />
      </div>
    </div>

    <div className="mt-6">
      <Table
        pagination={false}
        dataSource={billingHistory}
        columns={[
          {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
          },
          {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (text: string, row: any) => {
              return <div className="flex items-center gap-2">
                <div className="">
                  {text}
                </div>
                <div>
                  {
                    row.status === 'succeeded' ? <Tag color="success">
                      <div className="flex items-center gap-1">Succeeded <IoCheckmark /></div>
                    </Tag> : <Tag color="error">
                      {row.status}
                    </Tag>
                  }

                </div>
              </div>
            }
          },
          {
            title: 'Payment Method',
            dataIndex: 'payment_method',
            key: 'payment_method',
            render: (record: {
              brand: string;
              last4: string;
            }) => {
              return <div className="flex items-center gap-2">
                <div className="w-10">
                  <img src={getIcon(record.brand)} />
                </div>
                <div>
                  {record.brand}
                </div>
              </div>
            }
          },
          {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
          }
        ]} />
    </div>
    <Elements stripe={stripePromise} options={options as any}>
      <AddCardModal hasDefault={methods.length > 0} open={showModal} onCancel={() => setShowModal(false)} onSubmit={onSubmit} />
    </Elements>

  </div >
}

export default Billing